import { render, staticRenderFns } from "./OtherFacilitiesjudgedResultModal.vue?vue&type=template&id=59d68fc0&scoped=true&lang=pug"
import script from "./OtherFacilitiesjudgedResultModal.vue?vue&type=script&lang=ts"
export * from "./OtherFacilitiesjudgedResultModal.vue?vue&type=script&lang=ts"
import style0 from "./OtherFacilitiesjudgedResultModal.vue?vue&type=style&index=0&id=59d68fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d68fc0",
  null
  
)

export default component.exports